<template>
  <el-row>
    <template v-if="discount.priceRule">
      <el-col :span="8">
        <h6>Discount</h6>
      </el-col>
      <el-col :span="12">
        <small>
          ({{ discount.priceRule.value }} | {{ discount.priceRule.value_type }} |
          {{ discount.priceRule.target_selection }} | {{ discount.priceRule.target_type }})
        </small>
        <span v-if="isDiscountDisabled" class="text-danger">
          Discount Cannot be Replaced: {{ discount.priceRule.title }}
        </span>
        <i v-else @click="remove" class="el-icon-delete text-danger">
          - Remove Discount
        </i>
      </el-col>
      <el-col :span="4" class="text-right">
        <PriceDisplay
            :originalPrice="Number(totalDiscount)"
            :updatePrice="Number(totalDiscount)"
        />
      </el-col>
    </template>
  </el-row>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';
import {
  capitalize,
  percent,
} from '../../../../filters';
import {
  ORDER_DISCOUNT_REMOVE_CODE,
  ORDER_GET_DISCOUNT_AMOUNT,
  ORDER_GET_IS_DISCOUNT_DISABLED,
} from '../../../../store/types';
import PriceDisplay from '../../Shared/PriceDisplay';

export default {
  name: 'OrderDiscounts',
  components: {PriceDisplay},
  filters: {
    capitalize,
    percent,
  },
  computed: {
    ...mapState({
      discount: state => state.order.discount,
    }),
    ...mapGetters({
      totalDiscount: ORDER_GET_DISCOUNT_AMOUNT,
      isDiscountDisabled: ORDER_GET_IS_DISCOUNT_DISABLED,
    }),
  },
  methods: {
    ...mapActions({
      remove: ORDER_DISCOUNT_REMOVE_CODE,
    }),
  },
};
</script>
